interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schemaType?: string;
  schemaData?: Record<string, unknown>;
  noindex?: boolean;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  schemaType = 'WebPage',
  schemaData,
  noindex = false,
}: SEOHeadProps) {
  const fullTitle = title.includes('星空电影网') ? title : `${title} | 星空电影网`;
  const canonical = canonicalUrl || 'https://www.xingkongmovie.com';

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) canonicalEl.setAttribute('href', canonical);

    setMeta('og:type', ogType, true);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonical, true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);

    if (noindex) {
      setMeta('robots', 'noindex, follow');
    } else {
      setMeta('robots', 'index, follow');
    }
  }, [fullTitle, description, keywords, canonical, ogType, ogImage, noindex]);

  const defaultSchema = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: fullTitle,
    description: description,
    url: canonical,
    ...(schemaData || {}),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(defaultSchema),
      }}
    />
  );
}